module.exports = netmask;